import {auditIdHeader, bearerTokenHeader, externalUserHeader, kernoCustomerIdHeader} from "./auth-service";
import axios from "axios";

export async function getBankInformation(){
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/utils/bank/cat')
    return response.data;
}

export async function getPaymentReceipt(receiptId) {
    let combinedHeaders = Object.assign(bearerTokenHeader(), auditIdHeader());
    const response = await axios.get(process.env.REACT_APP_IP + '/insurancehub/extraction/policies/receipts/' + receiptId, {
        headers: combinedHeaders
    });
    return response.data;
}

export async function postPayment(cardData) {
    let jsonType = {"Content-Type" : "application/json; charset=UTF-8"}
    let combinedHeaders = Object.assign(bearerTokenHeader(), auditIdHeader(), jsonType);
    const response = await axios.post(process.env.REACT_APP_IP + '/v1/api/payments/topay', cardData, {
        headers: combinedHeaders
    });
    return response.data;
}